// Photo availability map: F-key -> public url
export const PHOTOS = {
  A109: "/photos/a109.jpg",
  A320F: "/photos/a320f.jpg",
  ACJ319: "/photos/acj319.jpg",
  AS350: "/photos/as350.jpg",
  AS355: "/photos/as355.jpg",
  AW119: "/photos/aw119.jpg",
  AW139: "/photos/aw139.jpg",
  AW169: "/photos/aw169.jpg",
  B200: "/photos/b200.jpg",
  B206: "/photos/b206.jpg",
  B407: "/photos/b407.jpg",
  B412: "/photos/b412.jpg",
  B427: "/photos/b427.jpg",
  B429: "/photos/b429.jpg",
  B738F: "/photos/b738f.jpg",
  BBJ: "/photos/bbj.jpg",
  C172: "/photos/c172.jpg",
  C206: "/photos/c206.jpg",
  C90: "/photos/c90.jpg",
  CARAVAN: "/photos/caravan.jpg",
  CIT2: "/photos/cit2.jpg",
  CIT3: "/photos/cit3.jpg",
  CITXL: "/photos/citxl.jpg",
  CJ: "/photos/cj.jpg",
  CL350: "/photos/cl350.jpg",
  CL605: "/photos/cl605.jpg",
  DAUPHIN: "/photos/dauphin.jpg",
  DHRUV: "/photos/dhruv.jpg",
  E175: "/photos/e175.jpg",
  EC130: "/photos/ec130.jpg",
  EC135: "/photos/ec135.jpg",
  ERJ135: "/photos/erj135.jpg",
  F2000: "/photos/f2000.jpg",
  F6X: "/photos/f6x.jpg",
  F7X: "/photos/f7x.jpg",
  F900: "/photos/f900.jpg",
  G150: "/photos/g150.jpg",
  G200: "/photos/g200.jpg",
  G5000: "/photos/g5000.jpg",
  G550: "/photos/g550.jpg",
  G6000: "/photos/g6000.jpg",
  G7500: "/photos/g7500.jpg",
  GEXPRESS: "/photos/gexpress.jpg",
  H145: "/photos/h145.jpg",
  H160: "/photos/h160.jpg",
  H400: "/photos/h400.jpg",
  HAWKER4000: "/photos/hawker4000.jpg",
  HAWKER8: "/photos/hawker8.jpg",
  HAWKER9: "/photos/hawker9.jpg",
  KA350: "/photos/ka350.jpg",
  LEGACY: "/photos/legacy.jpg",
  LINEAGE: "/photos/lineage.jpg",
  LJ40: "/photos/lj40.jpg",
  LJ45: "/photos/lj45.jpg",
  LJ60: "/photos/lj60.jpg",
  MI17: "/photos/mi17.jpg",
  P180: "/photos/p180.jpg",
  P2006: "/photos/p2006.jpg",
  P2010: "/photos/p2010.jpg",
  P68: "/photos/p68.jpg",
  PA46: "/photos/pa46.jpg",
  PC12: "/photos/pc12.jpg",
  PC24: "/photos/pc24.jpg",
  PHENOM100: "/photos/phenom100.jpg",
  PREMIER: "/photos/premier.jpg",
  R44: "/photos/r44.jpg",
  R66: "/photos/r66.jpg",
  S76: "/photos/s76.jpg",
  STEMME: "/photos/stemme.jpg",
  TWINOTTER: "/photos/twinotter.jpg",
};
